<script setup lang="ts">
import {currencyze} from "@/core/filters/Currencyze";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";

defineProps<{
    currentProfit?: number
    totalProfit?: number;
}>();
</script>

<template>
  <div class="grid grid-cols-4 shadow bg-white border-[1px] rounded-md border-primary text-sm items-center px-4 py-2 gap-4">
    <div>
      <p>Modules</p>
    </div>
    <div class="text-center">
      <p>Patients cibles</p>
    </div>
    <div class="text-primary flex justify-center flex-1 gap-1 item">
      <div>
        <p>
          Potentiel première année
        </p>
        <p class="text-base leading-none text-end">
          {{ currentProfit ? currencyze(currentProfit, 0) : '' }}
        </p>
      </div>
      <InformationTooltip class="w-4 h-4">
        <div>
          <p>Marge moyenne réalisée par les pharmacies Apodis</p>
        </div>
      </InformationTooltip>
    </div>
    <div class="text-primary font-bold text-end flex-1">
      <p>
        Potentiel Max
      </p>
      <p class="text-base leading-none">
        {{ totalProfit ? currencyze(totalProfit, 0) : '' }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
